import { createContext, FunctionComponent, useCallback, useMemo } from 'react';
import { singleton } from '@animavirtuality/utils';
import { useLocalStorage } from '@/hooks/useLocalStorage';

export type MuteContextValue = {
    soundEnabled: boolean;
    toggleSound: () => void;
};

export const MuteContext = singleton(() => createContext<MuteContextValue | null>(null));

export const MuteContextProvider: FunctionComponent = ({ children }) => {
    const [soundDisabled, setSoundEnabled] = useLocalStorage('soundDisabled', false);
    const toggleSound = useCallback(() => setSoundEnabled((current) => !current), [setSoundEnabled]);

    const value = useMemo(
        () => ({
            soundEnabled: !soundDisabled,
            toggleSound,
        }),
        [soundDisabled, toggleSound]
    );

    const context = MuteContext();
    return <context.Provider value={value}>{children}</context.Provider>;
};
